/**
 * @file schemas/conflict-of-interest.ts
 * @description 利益迴避（稽核員 × 客戶對）Zod 校驗 schema。
 */
import { z } from 'zod';
/**
 * 建立利益迴避記錄請求 schema。
 * P0 直接輸入 ID；M1 改為 autocomplete select。
 */
export const createConflictOfInterestSchema = z.object({
    /** 稽核員用戶 ID */
    auditorId: z.number().int().positive(),
    /** 客戶 ID */
    clientId: z.number().int().positive(),
    /** 迴避原因（必填） */
    reason: z.string().min(1),
});
/**
 * 更新利益迴避記錄請求 schema（所有欄位可選）。
 */
export const updateConflictOfInterestSchema = createConflictOfInterestSchema.partial();
